import { isFunction } from 'lodash-es'
import { TYPE } from '@/js/helper/messaging-constants.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'

const parseMessage = message => {
  try {
    return JSON.parse(message)
  } catch (e) {
    return undefined
  }
}

const checkSupportAccessKick = ({ notification, getters }) => {
  // ToDo: Only parse message once? -> changes in all notification components?
  const data = parseMessage(notification?.message)
  const targetId = data?.target
  console.log(targetId, getters[APP_GETTER.SUPPORT_USER])
  return targetId === getters[APP_GETTER.SUPPORT_USER]
}

const CHECKS = {
  // [TYPE.AVAILABILITY_AGAIN]: true,
  // [TYPE.AVAILABILITY_LOW]: true,
  // [TYPE.AVAILABILITY]: true,
  [TYPE.SYSTEM_SUPPORTACCESSKICK]: checkSupportAccessKick,
  // [TYPE.SYSTEM_SUPPORTACCESSLOGOUT]: true,
}

export const checkNotification = ({ notification, getters }) => {
  const { type } = notification
  return isFunction(CHECKS?.[type]) ? CHECKS[type]({ notification, getters }) : true
}
